// Le retour au choix du don démonte le formulaire de paiement pour libérer les
// réservations de lots. Son brouillon reste dans la page et est réappliqué au retour.
export function restoreCheckoutValues(defaults, draft, platforms, abo) {
    const values = {...defaults, ...(draft || {})}
    values.platform = platforms.some(option => option.value === draft?.platform)
        ? draft.platform : defaults.platform
    // La fréquence vient toujours du don qui vient d'être confirmé, pas du
    // formulaire affiché avant un éventuel changement de choix.
    values.abo = abo
    return values
}

// Le compte actif possède l'identité verrouillée, même si /me arrive après une
// saisie ou un retour au formulaire. Les autres champs modifiés restent conservés.
export function accountPrefillWithoutDraft(prefill, draft) {
    const identity = ["homme", "prenom", "nom", "email", "tel"]
    return Object.fromEntries(Object.entries(prefill).filter(([key]) =>
        identity.includes(key) || !Object.prototype.hasOwnProperty.call(draft || {}, key)))
}

// Ant Design ne transmet que les champs modifiés. Les champs propres à
// l'organisation sont imbriqués sous `extra` et arrivent un à un.
export function mergeCheckoutDraft(current, changes) {
    const merged = {...(current || {})}
    for (const [key, value] of Object.entries(changes || {})) {
        if (value && Object.getPrototypeOf(value) === Object.prototype &&
            merged[key] && Object.getPrototypeOf(merged[key]) === Object.prototype) {
            merged[key] = mergeCheckoutDraft(merged[key], value)
        } else {
            merged[key] = value
        }
    }
    return merged
}
